import script from "./MyBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./MyBanner.vue?vue&type=script&setup=true&lang=js"

import "./MyBanner.vue?vue&type=style&index=0&id=c7ebf006&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enterpriseprodex/sxpf-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7ebf006"]])

export default __exports__